import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const Technicians = {
  namespaced: true,
  state: {
    technician: null,
    technicians: [],
  },
  getters,
  mutations,
  actions,
}

export default Technicians
